<template>
  <div id="loaderoverlay" :style="{ display: onloader }">
    <div class="w-100 d-flex justify-content-center align-items-center">
      <div class="loaderspinner"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    onloader: String
  }
}
</script>

<style></style>
